import styles from './Container.module.css';
import cn from 'classnames';


export const Container = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.container, className)} {...props}>
      {children}
    </div>
  )
}
